import React, { Component } from 'react'
import moment from 'moment-timezone'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '8px 0',
    width: 88
  },
  bigText: {
    fontSize: 41,
  },
})


class AdditionalRecordings extends Component {
  render () {
    const { date, classes } = this.props

    return (
      <div className={classes.root}>
        <div className={classes.bigText}>+</div>
        <div>additional recordings</div>
      </div>
    )
  }
}

export default withStyles(styles)(AdditionalRecordings)



// WEBPACK FOOTER //
// ./src/components/AdditionalRecordings.js